import React from "react";
import MultiRowCarousel from "../../MultiRowsCarousel";
import leftArrow from "../../../../../assets/shapes_svg/ambition/left-arrow.svg";
import rightArrow from "../../../../../assets/shapes_svg/ambition/right-arrow.svg";
import "./index.css";
import { useNavigate } from "react-router-dom";

export const CustomList = ({
  className,
  newName,
  setNewName,
  handleSave,
  efforts,
  link,
}) => {
  const allSections = efforts ? efforts : [];
  const navigate = useNavigate();
  const handleItemClick = (item) => {
    navigate(link);
  };

  const ButtonGroup = ({ onNext, onPrevious }) => {
    return (
      <div className="carousel-navigation">
        <img
          src={leftArrow}
          onClick={onPrevious}
          alt="Previous"
          className="custom-nav-button"
        />
        <img
          src={rightArrow}
          onClick={onNext}
          alt="Next"
          className="custom-nav-button"
        />
      </div>
    );
  };

  const renderItem = (item) => (
    <div className="custom-action-item" onClick={() => handleItemClick(item)}>
      <h4>{item.name}</h4>
    </div>
  );

  return (
    <div className="custom-action-container">
      <MultiRowCarousel
        containerClassName="custom"
        items={allSections}
        rowsPerSlide={2}
        itemsPerRow={3}
        CustomButtonGroup={ButtonGroup}
        renderItem={renderItem}
        className={className}
        newName={newName}
        setNewName={setNewName}
        handleSave={handleSave}
      />
    </div>
  );
};
